import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import { Button } from "vant";
import {
  Cell,
  CellGroup,
  Progress,
  Circle,
  Icon,
  Toast,
  Field,
  ActionSheet,
  Cascader,
  Popup,
  NavBar,
  Picker,
  Dialog,
  RadioGroup,
  Radio,
  Uploader,
  Checkbox,
  CheckboxGroup,
  List,
  Grid,
  GridItem
} from "vant";
import { Image as VanImage } from "vant";
import IconSvg from "./components/iconfontSvg.vue";

import "./assets/icon/iconfont.js";
import "./styles/normalize.css";
import "./styles/index.less";
import "./assets/icon/iconfont.css";
// 动态设置REM基准值
import "amfe-flexible";

const app = createApp(App);
app.use(Dialog);
app.use(Picker);
app.use(NavBar);
app.use(ActionSheet);
app.use(Field);
app.use(CellGroup);
app.use(Cascader);
app.use(Popup);
app.use(Uploader);
app.use(Checkbox);
app.use(CheckboxGroup);
app.use(List);
app.use(Grid);
app.use(GridItem);

app
  .use(Toast)
  .use(Button)
  .use(Cell)
  .use(CellGroup)
  .use(VanImage)
  .use(Progress)
  .use(Circle)
  .use(Icon)
  .use(Radio)
  .use(RadioGroup);
app.component("IconSvg", IconSvg);
app.use(store).use(router).mount("#app");
